
import $ from 'jquery';

const GotoScroll = function (target, status) {
    let off = 0;

    // Add offset to onload status
    if (status === 'load') {
        target = $('[name="' + target + '"]');
        off = off - 142;
    }

    if (target.length) {

        off = off + target.offset().top;
        off = off - $('.fix_header').outerHeight();
        off = off - $('header nav').outerHeight();

        $('html,body').animate({
            scrollTop: off
        }, 1000);
    }
};

export default GotoScroll;